import { render, staticRenderFns } from "./takeStockRecord.vue?vue&type=template&id=00b73dc6"
import script from "./takeStockRecord.vue?vue&type=script&lang=js"
export * from "./takeStockRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports